<template>
    <div>
        <div class="row card-body">
            <div class="mb-3-rem" v-if="canSignByImpersonation && constants.enableImpersonateSignatureInDelegation">
                <label v-for="option in SignAsOptions" :key="option.value" class="radio-label">
                    <input type="radio" :value="option.value" v-model="SelectedSignAsOption" class="radio-input">
                    {{ option.label }}
                </label>
            </div>
            <div class="col-md-12">
                <label class="mb-2">{{$t("res_Label_PinValue")}}</label>
                <v-text-field v-model="pinValue" label="" solo type="password"></v-text-field>
            </div>
        </div>
        <div style="padding-top: 15px;">
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelDialog">{{$t("res_ButtonText_Cancel")}}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important;" :disabled="!validForm" @click="signDocument">{{$t("res_ButtonText_Continue")}}</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
    import constants from '@/assets/js/constants'
    import axios from 'axios'

	export default {
		name: 'Sign',
		data() {
            return {
                pinValue: '',
                validForm: false,
                canSignByImpersonation:false,
                SignAsOptions: [{ label: 'On behalf', value: false }, { label: 'Impersonation', value: true}],
                SelectedSignAsOption: false ,
                constants:constants,
            };
        },
        props: {
            documentId: { type: Number, required: false },
            transferId: { type: Number, required: false },
            delegationId: { type: Number, required: false },
            dialogModelShow: { type: Boolean, default: false },
            propertyBag: { type: Object },
            isSignAndSend: {type: Boolean, default: false}
        },
        methods:
        {
            getPermissionToSign()
            {
                // this.documentId, this.transferId, this.delegationId
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.propertyBag.delegationId)
                    .then(res =>
                    {
                        if (res.data == 'SignaturePinNotSet')
                            window.showAlert('res_Msgs_PinNotSet', 'warning')

                        else if (res.data == 'NoDefaultSignatureFound')
                            window.showAlert('res_Msgs_NoDefaultSignature', 'warning')
                        
                        else
                            this.validForm = true
                    })
                    .catch(err => window.showAlert(err, 'error'))
                    .finally(() => window.hideLoading())
            },
            signDocument()
            {
                if (this.pinValue == '')
                {
                    window.showAlert('res_Msgs_EnterPin', 'warning')
                }
                else
                {
                    window.showLoading()
                    axios.get(constants.baseApiUrl + 'Document/CheckHasValidPin?pinValue=' + this.pinValue)
                        .then(res =>
                        {
                            if (res.data == false)
                            {
                                window.hideLoading()
                                window.showAlert('res_Msgs_InvalidPin', 'error')
                            }
                            else
                            {

                                axios.post(constants.baseApiUrl + 'Document/SignDocument?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.propertyBag.delegationId+'&impersonatedSignature='+this.SelectedSignAsOption+'&enableRecipientsMultiPages='+this.constants.enableRecipientsMultiPages+'&isSignAction='+!this.isSignAndSend)
                                    .then(res =>
                                    {
                                        window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                                            if (this.isSignAndSend)
                                            {
                                                window.showLoading()
                                                this.$emit('uaeDocumentSigned')
                                            }
                                            else
                                                this.$emit('refreshAfterClosingSignDialog')
                                    })
                                    .catch(error => console.log(error))
                                    .finally(() => window.hideLoading())
                            }
                        })
                        .catch(error => { console.log(error); window.hideLoading(); })
                }
            },
            CheckSignatureImpersonation()
            {
                axios.get(constants.baseApiUrl + 'Delegation/CanImpersonatedSign?delegationId=' + this.propertyBag.delegationId)
                    .then(res => {
                        this.canSignByImpersonation = res.data
                    })
                    .catch(err => console.log(err));
            },
            cancelDialog()
            {
                this.$emit('closeSignFormDialog');
            },
            resetForm()
            {
                this.pinValue = ''
                this.validForm = false
                this.canSignByImpersonation=false
                this.SelectedSignAsOption= false
            }
        },
        watch:
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                    {
                        this.getPermissionToSign()
                        this.CheckSignatureImpersonation()
                    }
                    else
                        this.resetForm()
                }
            }
        },
        mounted: function ()
        {
            this.getPermissionToSign()
            this.CheckSignatureImpersonation()
        }
	}
</script>